document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.hasAttribute('hidden');
  if (open) menu.removeAttribute('hidden');
  else menu.setAttribute('hidden', '');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});
